import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const eventDetailGridColumns = (rows) => columnDefs(rows);

function columnDefs(rows) {

    let tempColumnDefs = [];
    rows.map((object) => {
        Object
            .keys(object)
            .map((key) => {
                const mappedColumn = {
                    headerName: key,
                    field: key,
                };
                tempColumnDefs.push(mappedColumn);
            });
    });

    tempColumnDefs = tempColumnDefs.filter((column, index, self) =>
        index === self.findIndex((colAtIndex) => (
            colAtIndex.field === column.field)));

    const columnDefs = [];
    const durationVF = ({ value }) => apiProvider.formatDuration({ seconds: value });
    for (const each of tempColumnDefs) {
        if (each.headerName !== 'id') {
            let hide = false;
            let valueFormatter = null;
            let cellRenderer = null;
            let suppressColumnsToolPanel = false
            let suppressFiltersToolPanel = false

            let width = 120;
            if (each.headerName === apiProvider.getEntityUpper() + ' #') width = 100
            if (each.headerName === 'From Activity') width = 150
            if (each.headerName === 'To Activity') width = 150
            if (each.headerName === 'Actual Cost' || each.headerName === 'Forecast Cost') hide = true

            let flex = 1;
            if (each.headerName === 'ID' || each.headerName === 'k') {
                suppressFiltersToolPanel = true
                suppressColumnsToolPanel = true
            }

            if (each.headerName === 'Duration'|| each.headerName === 'Time Spent' ) {
                valueFormatter = durationVF;
            }
            if (each.headerName === 'k' || each.headerName === 'ID') {
                hide = true;
            }
            columnDefs.push({
                headerName: each.headerName,
                field: each.field,
                hide,
                width,
                flex,
                valueFormatter,
                cellRenderer,
                suppressColumnsToolPanel,
                suppressFiltersToolPanel
            });
        }
        
    }
    console.log(columnDefs)
    return columnDefs;
}

/*
                    vtp['suppressColumnsToolPanel'] = true
    vtp['suppressFiltersToolPanel'] = true
*/